export default function buildSearchParams(search, options) {
  const params = {};
  const route = this && this.$route ? this.$route : null;
  const routeParams = route && route.params ? route.params : {};
  const routeName = route && typeof route.name === "string" ? route.name : "";
  const hasRouteContext =
    Object.keys(routeParams).length > 0 || routeName.includes("create");

  for (const key in search) {
    if (key === "trigger") {
      continue;
    } else if (typeof search[key] === "boolean") {
      params[key] = search[key] ? "true" : "false";
    } else if (
      search[key] !== null &&
      search[key].constructor.name === "Object"
    ) {
      if (JSON.stringify(search[key]) !== "{}") {
        params[key] = {};
        for (const index in search[key]) {
          if (search[key][index] !== "") {
            params[key][index] = search[key][index];
          }
        }
      }
    } else if (search[key]) {
      params[key] = search[key];
    }
  }

  if (options) {
    if (options.sortBy && options.sortBy.length > 0) {
      params.order_by = options.sortBy[0];
      params.order = options.sortDesc[0] === true ? "desc" : "asc";
    }

    if (options.itemsPerPage) {
      params.per_page = options.itemsPerPage;
    }

    params.page = options.page;

    if (hasRouteContext) {
      params.page = options.page;
    } else {
      const page =
        typeof window !== "undefined"
          ? window.location.search.split("?page=")[1]
          : null;
      if (page == options.page) {
        params.page = page;
      } else {
        params.page = options.page;
      }
    }
  }

  return params;
}
